import React from "react";

function FAQ() {
  return (
    <React.Fragment>
      <h1>Welcome to Graph.Chart!</h1>
      <p>This site was being developed by React.JS</p>
    </React.Fragment>
  );
}

export default FAQ;
